<template>
    <div class="container padded-top">
        <div id="media-status" class="container">
            <div class="row">
                <div class="col-sm-8 with-border">

                    <h2 class="page-title uppercase large-margin">Media Status</h2>

                    <div class="activities">
                        <div class="media-box d-flex">
                            <div>
                                <h3 class="activity-title">Bungy & Skyjump</h3>
                            </div>
                            <div>
                                <media v-if="mediaStatusIsLoaded" :media="mediaStatus[0]" :mediaLabel="'Canon'" :isDisable="false" />
                                <media v-if="mediaStatusIsLoaded" :media="mediaStatus[1]" :mediaLabel="'GoPro'" :isDisable="false" />
                                <media v-if="mediaStatusIsLoaded" :media="mediaStatus[2]" :mediaLabel="'Photos'" :isDisable="false" />
                            </div>
                        </div>
                        <div class="media-box d-flex">
                            <div><h3 class="activity-title">Skywalk</h3></div>
                            <media v-if="mediaStatusIsLoaded" :media="mediaStatus[3]" :mediaLabel="'Media'" :isDisable="true" />
                        </div>
                        <div class="media-box d-flex">
                            <div><h3 class="activity-title">Tower Climb</h3></div>
                            <media v-if="mediaStatusIsLoaded" :media="mediaStatus[4]" :mediaLabel="'Media'" :isDisable="true" />
                        </div>
                    </div>

                    <div class="media-status-p">
                        <p>This is used when a media type is temporarily not available.</p>
                        <p>Disabling the media type will stop it from blocking the completion of the media upload.</p>
                    </div>

                    <div class="actions">
                        <div class="d-flex align-items-center">
                            <button :disabled="isSubmitted" @click="updateSettings" type="submit" class="submit" name="save">Save Changes</button>
                            <a href="/ap" class="cancel">Cancel</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {mapActions, mapState} from 'vuex';
import media from './MediaStatus';

export default {
    data() {
        return {
            isSubmitted: false
        }
    },
    components: {
        media
    },
    computed: {
        ...mapState(['mediaStatus', 'mediaStatusIsLoaded'])
    },
    methods: {
        ...mapActions(['fetchMediaStatus']),
        updateSettings() {
            this.isSubmitted = true;

            axios.post('/ap/media-status/update', {'media_status': this.$store.state.mediaStatus})
                .then(({data}) => {
                    toastr.success("Media status successfully updated.");
                    this.isSubmitted = false;
                })
                .catch(error => {
                    this.isSubmitted = false;
                    toastr.error(error.response.data.message);
                });

            this.$store.dispatch('checkIfMediaIsDisabled');
        },
    },
    mounted() {
        this.fetchMediaStatus();
    }
}
</script>